module.exports = __webpack_public_path__ + "img/Slide6.083c9359.png";